import React, { ReactElement } from 'react';

import { CalendarMode } from '@philips-emr/tws-constants';
import { classNames } from '@philips-emr/tws-utils';

interface ModeProps {
  active: boolean;
  mode: CalendarMode;
  onClick: (mode: CalendarMode) => void;
}

function Mode({ active, mode, onClick }: ModeProps ): ReactElement {
  const className = classNames({
    'c-calendar__month-visualization': mode === CalendarMode.MONTHLY,
    'c-calendar__week-visualization': mode === CalendarMode.WEEKLY,
    'active': active,
  });

  return (
    <div
      className={className}
      data-testid={`calendar-${mode}-mode`}
      onClick={() => onClick(mode)}
    />
  );
}

interface ModeChangerProps {
  canChangeMode: boolean;
  mode: CalendarMode;
  onChange: (mode: CalendarMode) => void;
}

function ModeChanger({ canChangeMode, mode, onChange }: ModeChangerProps): ReactElement | null {
  if (!canChangeMode) {
    return null;
  }

  return (
    <div className="c-calendar__visualizations">
      <Mode active={mode === CalendarMode.WEEKLY} mode={CalendarMode.WEEKLY} onClick={onChange} />
      <Mode active={mode === CalendarMode.MONTHLY} mode={CalendarMode.MONTHLY} onClick={onChange} />
    </div>
  );
}

export default ModeChanger;
